import { formatMicro, TOKEN_SYMBOL } from "../lib/money";

/**
 * Exact USDG amount from integer micro-units (string or bigint). Never rounds: "exact" prints 6 decimals,
 * "compact" drops trailing zeros (keeping at least 2), so 0.000450 stays 0.00045 and never becomes 0.00.
 */
export function Amount({ micro, big, unit = true, label, trim, mode }: {
  micro: string | bigint | null | undefined;
  big?: boolean;
  unit?: boolean;
  label?: string;
  /** legacy alias of mode="compact" */
  trim?: boolean;
  mode?: "exact" | "compact";
}) {
  if (micro === null || micro === undefined) return <span className="amount">not available</span>;
  const text = formatMicro(micro, { trim: trim || mode === "compact" });
  return (
    <span className={`amount${big ? " big" : ""}`} aria-label={label ? `${label}: ${text} ${TOKEN_SYMBOL}` : undefined}>
      {text}
      {unit ? <span className="unit">{TOKEN_SYMBOL}</span> : null}
    </span>
  );
}
